import CarouselItem from "../CarouselItem/CarouselItem";
const Carousel = () => {
  
    return (

        <>
          <CarouselItem/>  
        </>
    );
}

export default Carousel;

